export default __webpack_public_path__ + "static/media/Group 16705.d6d28f5f.svg";